import { Link } from '@tanstack/react-router';
import { CircleArrowUpIcon, Lightbulb, TagIcon, WaypointsIcon } from 'lucide-react';
import { useGetSubscription } from '@/api/subscription/queries';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

export function NavSecondary() {
  const { data } = useGetSubscription();
  const { isMobile, setOpenMobile } = useSidebar();

  const handleLinkClick = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <SidebarGroup className="mt-auto">
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip="Upgrade">
              {data?.isFree ? (
                <Link
                  to="/pricing"
                  className="text-orange-800 dark:text-orange-200 border bg-orange-200/10 dark:bg-orange-800/10 hover:bg-orange-200/20! dark:hover:bg-orange-300/20! border-orange-800 dark:border-orange-300 shadow-lg shadow-orange-800/15 dark:shadow-orange-500/15"
                  activeProps={{
                    className:
                      'bg-orange-300/20! dark:bg-orange-300/20! text-orange-800 dark:text-orange-200 border border-orange-400',
                  }}
                  onClick={handleLinkClick}
                >
                  <CircleArrowUpIcon />
                  Upgrade Plan
                </Link>
              ) : (
                <Link
                  to="/pricing"
                  activeProps={{ className: 'bg-sidebar-accent' }}
                  onClick={handleLinkClick}
                >
                  <TagIcon className="text-muted-foreground" />
                  Pricing Plan
                </Link>
              )}
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip="Suggest a Feature">
              <Link
                to="/feature-request"
                activeProps={{ className: 'bg-sidebar-accent' }}
                onClick={handleLinkClick}
              >
                <Lightbulb className="text-muted-foreground" />
                Suggest a Feature
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip="Features Roadmap">
              <Link
                to="/roadmap"
                activeProps={{ className: 'bg-sidebar-accent' }}
                onClick={handleLinkClick}
              >
                <WaypointsIcon className="text-muted-foreground" />
                Features Roadmap
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
